import { Component} from '@angular/core';

@Component({
    selector: 'ivr-assignment-user-task-main',
    templateUrl: './ivr-assignment-user-task-main.tmpl.html'
})

export class IvrAssignmentUserTaskMain {  
}
  